// import type { RouterConfig } from '@nuxt/schema' // Commented out - module not found
import type { RouteLocationNormalized, RouteLocationNormalizedLoaded } from 'vue-router'

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default {
  scrollBehavior(
    to: RouteLocationNormalized, 
    from: RouteLocationNormalizedLoaded, 
    savedPosition: { left: number; top: number } | null
  ) {
    // If we have a saved position (navigating back/forward), use it
    if (savedPosition) {
      return savedPosition
    }

    // Check if only the quickView parameter changed
    const onlyQuickViewChanged = () => {
      if (to.path !== from.path) return false;
      
      const toQuery = { ...to.query };
      const fromQuery = { ...from.query };
      
      // Remove quickView from both for comparison
      const hasQuickViewChanged = toQuery.quickView !== fromQuery.quickView;
      delete toQuery.quickView;
      delete fromQuery.quickView;
      
      // If all other query params are the same, then only quickView changed
      return hasQuickViewChanged && 
        JSON.stringify(toQuery) === JSON.stringify(fromQuery);
    };
    
    // If only the quickView parameter changed, don't scroll
    if (onlyQuickViewChanged()) {
      return false; // Prevents scrolling
    }

    // Check if navigating from vehicle list pages to vehicle detail page
    const isNavigatingFromListToDetail = () => {
      const listPaths = ['/cars-for-sale', '/vehicles'];
      const isFromList = listPaths.includes(from.path);
      const isToDetail = to.path.startsWith('/vehicle-for-sale/');
      return isFromList && isToDetail;
    };

    // Don't trigger scroll behavior when going from list to detail
    // The detail page will handle its own scrolling in onMounted
    if (isNavigatingFromListToDetail()) {
      return false;
    }

    // If there's a hash, scroll to it smoothly
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }

    // Otherwise, scroll to the top of the page
    return { top: 0, behavior: 'instant' }
  },
}
